import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@src/design-system/dialog';
import { cn } from '@src/design-system/helpers';
import { Element } from 'iconsax-react';
import { CustomFieldListDialog } from './custom-field-list-dialog';
import { TableActionIconButton } from '@src/design-system/molecules/ticlick-table/actions';

export const CustomFieldListDialogTrigger = () => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <TableActionIconButton
          label='Custom Fields'
          className={cn('bg-white border-primary-200')}
          icon={<Element className='text-secondary-1000' />}
        />
      </DialogTrigger>

      <DialogContent>
        <CustomFieldListDialog />
      </DialogContent>
    </Dialog>
  );
};
